export enum AnimationType {
  /** 入场动画 */
  In = 'anim_in',
  /** 出场动画 */
  Out = 'anim_out',
  /** 组合动画 */
  Inout = 'anim_inout',
  /** 循环动画 */
  Loop = 'anim_loop',
}
